import type { TranslationKeys } from '../types';

export const azAZ: TranslationKeys = {
  // Home page
  'home.title': 'Süni intellekt əsaslı görüş platforması',
  'home.createMeeting': 'Yeni görüş yarat',
  'home.creating': 'Yaradılır...',
  'home.or': 'və ya',
  'home.joinPlaceholder': 'Kod və ya linki daxil edin',
  'home.join': 'Qoşul',
  'home.errorDefault': 'Xəta baş verdi',
  'home.meetingCreateFailed': 'Görüş yaradıla bilmədi',
  'home.poweredBy': 'Təminatçı',

  // Join page
  'join.unableToJoin': 'Görüşə qoşulmaq mümkün deyil',
  'join.tryAgain': 'Yenidən cəhd edin',
  'join.creatingSession': 'Yeni sessiya yaradılır...',
  'join.joiningMeeting': 'Görüşə qoşulur...',
  'join.loadingInfo': 'Görüş məlumatları yüklənir...',
  'join.failedToJoin': 'Görüşə qoşulmaq mümkün olmadı',
  'join.unexpectedError': 'Gözlənilməz xəta baş verdi',
  'join.encounteredError': 'Gözlənilməz xəta baş verdi: {message}',
  'join.meetingDetails': 'Görüş təfərrüatları',
  'join.ok': 'Tamam',
  'join.cameraUnavailable': 'Kamera əlçatan deyil, başqa tətbiq onu istifadə edə bilər.',
  'join.micUnavailable': 'Mikrofon əlçatan deyil, başqa tətbiq onu istifadə edə bilər.',
  'join.mediaDeviceError': 'Media cihazı xətası: {message}',

  // PreJoin
  'prejoin.joinLabel': 'Otağa qoşul',
  'prejoin.userLabel': 'İstifadəçi adı',
  'prejoin.micLabel': 'Mikrofon',
  'prejoin.camLabel': 'Kamera',

  // Settings menu
  'settings.mediaDevices': 'Media cihazları',
  'settings.recording': 'Qeyd',
  'settings.camera': 'Kamera',
  'settings.microphone': 'Mikrofon',
  'settings.speakerHeadphones': 'Dinamik və qulaqlıq',
  'settings.audioOutput': 'Səs çıxışı',
  'settings.recordMeeting': 'Görüşü qeyd et',
  'settings.meetingRecording': 'Görüş qeyd olunur',
  'settings.noActiveRecordings': 'Bu görüş üçün aktiv qeyd yoxdur',
  'settings.startRecording': 'Qeydə başla',
  'settings.stopRecording': 'Qeydi dayandır',
  'settings.close': 'Bağla',

  // Control bar
  'controls.microphone': 'Mikrofon',
  'controls.camera': 'Kamera',
  'controls.leave': 'Ayrıl',
  'controls.chat': 'Söhbət',
  'controls.shareScreen': 'Ekranı paylaş',
  'controls.stopScreenShare': 'Paylaşmanı dayandır',
  'controls.settings': 'Parametrlər',
  'controls.pause': 'Görüşü fasilələ',
  'controls.allowAudio': 'Səsi aktivləşdir',

  // Chat panel
  'chat.title': 'Mesajlar',
  'chat.placeholder': 'Mesaj yazın...',
  'chat.send': 'Göndər',
  'chat.close': 'Söhbəti bağla',

  // Connection state toast
  'connection.connecting': 'Qoşulur',
  'connection.reconnecting': 'Yenidən qoşulur',
  'connection.disconnected': 'Bağlantı kəsildi',

  // Participant tile
  'participant.screenShareSuffix': ' – ekranı',

  // Question panel
  'question.speakAnswer': 'Zəhmət olmasa şifahi cavab verin',

  // Pause overlay
  'pause.title': 'Görüş fasilədədir',
  'pause.description': 'Hazır olduqda qaldığınız yerdən davam edə bilərsiniz.',
  'pause.resume': 'Görüşə davam et',
  'pause.failed': 'Görüş fasiləyə salına bilmədi. Zəhmət olmasa yenidən cəhd edin.',
  'pause.resumeFailed': 'Görüşə davam etmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.',
  'pause.pausing': 'Görüş fasiləyə salınır...',
  'pause.resuming': 'Görüşə davam edilir...',
  'pause.waitingAgent': '{name} gözlənilir...',
  'pause.agentFallback': 'köməkçi',

  // Common
  'common.processing': 'Emal olunur...',
  'common.close': 'Bağla',
  'common.download': 'Yüklə',
  'common.image': 'Şəkil',
  'common.previousTab': 'Əvvəlki tab',
  'common.nextTab': 'Növbəti tab',

  // Content panel
  'content.openPdf': 'PDF-i aç',
  'content.pdfHint': 'PDF yeni tabda açılacaq',
  'content.loadingPdf': 'PDF yüklənir...',
  'content.loadingImage': 'Şəkil yüklənir...',
  'content.imageLoadFailed': 'Şəkil yüklənmədi. Yükləmə düyməsindən istifadə edin.',
  'content.clickDownload': 'Açmaq üçün yükləmə düyməsinə klikləyin',
  'content.document': 'Sənəd',
  'content.text': 'Mətn',
  'content.tabQuestion': 'SUAL',
  'content.tabText': 'MƏTN',
  'content.tabFile': 'FAYL',
  'content.badgeImage': 'ŞƏKİL',
  'content.badgeFile': 'FAYL',

  // Presentation panel
  'presentation.loading': 'Təqdimat yüklənir…',
  'presentation.loadingDetail': 'markdown: {count} simvol',
  'presentation.initFailed': 'Təqdimat işə salına bilmədi',

  // Mermaid diagram
  'diagram.loading': 'Diaqram yüklənir...',
  'diagram.syntaxError': 'Diaqram sintaksis xətası',
  'diagram.renderFailed': 'Diaqram yaradıla bilmədi',

  // Public slide preview page
  'preview.apiUrlMissing': 'API ünvanı konfiqurasiya edilməyib',
  'preview.loadFailed': 'Təqdimat yüklənə bilmədi',
  'preview.loading': 'Yüklənir…',

  // Settings menu
  'settings.backgroundEffects': 'Fon Effektləri',
  'settings.backgroundNone': 'Yoxdur',
  'settings.backgroundBlur': 'Bulanıqlaşdır',
  'settings.backgroundDesk': 'İş masası',
  'settings.backgroundNature': 'Təbiət',
  'settings.enableNoiseCancellation': 'Təkmilləşdirilmiş Səs-küy Süzgəcini Aç',
  'settings.disableNoiseCancellation': 'Təkmilləşdirilmiş Səs-küy Süzgəcini Bağla',
  'settings.recordingNoEndpoint': 'Qeyd ünvanı təyin edilməyib',
  'settings.recordingEncryptedUnsupported':
    'Şifrələnmiş görüşlərin qeydi hazırda dəstəklənmir',
  'settings.recordingInProgress': 'Bu görüş qeydə alınır',

  // Sent to the AI agent
  'agent.questionDismissed':
    '[İstifadəçi sual pəncərəsini cavab vermədən bağladı, təbii şəkildə davam et]',
};
